import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-thirty-nine',
  templateUrl: './home-thirty-nine.component.html',
  styleUrls: ['./home-thirty-nine.component.scss']
})
export class HomeThirtyNineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
